import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// --- ADONISIAN CALENDAR DATA ---
const ADONISIAN_MONTHS = [
  { name: "The Root", icon: "🌱", range: "Mar 20 - Apr 16" },
  { name: "The Sprout", icon: "🌿", range: "Apr 17 - May 14" },
  { name: "The Blossom", icon: "🌸", range: "May 15 - Jun 11" },
  { name: "The Canopy", icon: "🌳", range: "Jun 12 - Jul 9" },
  { name: "The Ray", icon: "☀️", range: "Jul 10 - Aug 6" },
  { name: "The Harvest", icon: "🌾", range: "Aug 7 - Sep 3" },
  { name: "The Seed", icon: "🌰", range: "Sep 4 - Oct 1" },
  { name: "The Fall", icon: "🍂", range: "Oct 2 - Oct 29" },
  { name: "The Stillness", icon: "❄️", range: "Oct 30 - Nov 26" },
  { name: "The Frost", icon: "💎", range: "Nov 27 - Dec 24" },
  { name: "The Deep", icon: "🌊", range: "Dec 25 - Jan 21" },
  { name: "The Thaw", icon: "💧", range: "Jan 22 - Feb 18" },
  { name: "The Awakening", icon: "🔥", range: "Feb 19 - Mar 18" }
];

const DAILY_TOTEMS = [
  "Rabbit", "Mouse", "Moose", "Goose", "Eagle", "Dragon", "Lion", 
  "Badger", "Ant", "Mermaid", "Whale", "Hawk", "Wolf", "Bear", 
  "Owl", "Fox", "Stag", "Serpent", "Turtle", "Panther", "Raven", 
  "Tiger", "Dolphin", "Swan", "Mantis", "Phoenix", "Elephant", "Scarab"
];

// --- 26 MOON SOMATIC EVENT DATABASE ---
const LUNAR_EVENTS_2026 = {
  0: [ // Month 1 (The Root)
    { date: "April 2, 2026", phase: "Full Moon", sign: "Virgo", somatic: "Enteric Nervous System / Lumbar Spine", chakra: "Manipura (Solar Plexus)" },
    { date: "April 16, 2026", phase: "New Moon", sign: "Pisces", somatic: "Lymphatic System / Pedal Extremities", chakra: "Svadhisthana (Sacral)" }
  ],
  1: [ // Month 2 (The Sprout)
    { date: "May 1, 2026", phase: "Full Moon", sign: "Libra", somatic: "Renal System / Sacral Iliac Joint", chakra: "Anahata (Heart)" },
    { date: "May 15, 2026", phase: "New Moon", sign: "Aries", somatic: "Cerebral Cortex / Atlas Vertebra (C1)", chakra: "Ajna (Third Eye)" }
  ],
  2: [ // Month 3 (The Blossom)
    { date: "May 31, 2026", phase: "Full Moon", sign: "Scorpio", somatic: "Reproductive Matrix / Coccyx", chakra: "Muladhara (Root)" },
    { date: "June 14, 2026", phase: "New Moon", sign: "Taurus", somatic: "Vocal Cords / Cervical Spine (C3-C7)", chakra: "Vishuddha (Throat)" }
  ],
  3: [ // Month 4 (The Canopy)
    { date: "June 29, 2026", phase: "Full Moon", sign: "Ophiuchus", somatic: "Cerebrospinal Vault / Medulla Oblongata", chakra: "Sahasrara (Crown)" },
    { date: "July 14, 2026", phase: "New Moon", sign: "Gemini", somatic: "Pulmonary Matrix / Thoracic Spine (T1-T4)", chakra: "Vishuddha (Throat)" }
  ],
  4: [ // Month 5 (The Ray)
    { date: "July 29, 2026", phase: "Full Moon", sign: "Sagittarius", somatic: "Hepatic System / Sciatic Nerve", chakra: "Svadhisthana (Sacral)" },
    { date: "August 12, 2026", phase: "New Moon", sign: "Cancer", somatic: "Gastric System / Thoracic Spine (T5-T8)", chakra: "Manipura (Solar Plexus)" }
  ],
  5: [ // Month 6 (The Harvest)
    { date: "August 28, 2026", phase: "Full Moon", sign: "Capricorn", somatic: "Skeletal Matrix / Patellar Tendons", chakra: "Muladhara (Root)" },
    { date: "September 11, 2026", phase: "New Moon", sign: "Leo", somatic: "Cardiac Muscle / Thoracic Spine (T9-T12)", chakra: "Anahata (Heart)" }
  ],
  6: [ // Month 7 (The Seed)
    { date: "September 26, 2026", phase: "Full Moon", sign: "Aquarius", somatic: "Circulatory System / Distal Tibiofibular", chakra: "Sahasrara (Crown)" },
    { date: "October 10, 2026", phase: "New Moon", sign: "Virgo", somatic: "Enteric Nervous System / Lumbar Spine", chakra: "Manipura (Solar Plexus)" }
  ],
  7: [ // Month 8 (The Fall)
    { date: "October 26, 2026", phase: "Full Moon", sign: "Pisces", somatic: "Lymphatic System / Pedal Extremities", chakra: "Svadhisthana (Sacral)" },
    { date: "November 9, 2026", phase: "New Moon", sign: "Libra", somatic: "Renal System / Sacral Iliac Joint", chakra: "Anahata (Heart)" }
  ],
  8: [ // Month 9 (The Stillness)
    { date: "November 24, 2026", phase: "Full Moon", sign: "Aries", somatic: "Cerebral Cortex / Atlas Vertebra (C1)", chakra: "Ajna (Third Eye)" },
    { date: "December 8, 2026", phase: "New Moon", sign: "Scorpio", somatic: "Reproductive Matrix / Coccyx", chakra: "Muladhara (Root)" }
  ],
  9: [ // Month 10 (The Frost)
    { date: "December 24, 2026", phase: "Full Moon", sign: "Taurus", somatic: "Vocal Cords / Cervical Spine (C3-C7)", chakra: "Vishuddha (Throat)" },
    { date: "January 7, 2027", phase: "New Moon", sign: "Ophiuchus", somatic: "Cerebrospinal Vault / Medulla Oblongata", chakra: "Sahasrara (Crown)" }
  ],
  10: [ // Month 11 (The Deep)
    { date: "January 22, 2027", phase: "Full Moon", sign: "Gemini", somatic: "Pulmonary Matrix / Thoracic Spine (T1-T4)", chakra: "Vishuddha (Throat)" },
    { date: "February 6, 2027", phase: "New Moon", sign: "Sagittarius", somatic: "Hepatic System / Sciatic Nerve", chakra: "Svadhisthana (Sacral)" }
  ],
  11: [ // Month 12 (The Thaw)
    { date: "February 21, 2027", phase: "Full Moon", sign: "Cancer", somatic: "Gastric System / Thoracic Spine (T5-T8)", chakra: "Manipura (Solar Plexus)" },
    { date: "March 8, 2027", phase: "New Moon", sign: "Capricorn", somatic: "Skeletal Matrix / Patellar Tendons", chakra: "Muladhara (Root)" }
  ],
  12: [ // Month 13 (The Awakening)
    { date: "March 22, 2027", phase: "Full Moon", sign: "Leo", somatic: "Cardiac Muscle / Thoracic Spine (T9-T12)", chakra: "Anahata (Heart)" },
    { date: "April 6, 2027", phase: "New Moon", sign: "Aquarius", somatic: "Circulatory System / Distal Tibiofibular", chakra: "Sahasrara (Crown)" }
  ]
};

const linkStyle = { 
  color: '#0d1117', 
  backgroundColor: '#ffca28', 
  padding: '10px 20px', 
  borderRadius: '4px', 
  textDecoration: 'none', 
  marginTop: '40px', 
  display: 'inline-block', 
  fontWeight: 'bold', 
  letterSpacing: '1px' 
};

export default function MoonCalculator() {
  const [birthDate, setBirthDate] = useState('1990-05-14');
  const [result, setResult] = useState(null);
  const [activeMonthIndex, setActiveMonthIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const calculateAdonisian = (dateString) => {
    if (!dateString) return;
    const inputDate = new Date(dateString);
    const year = inputDate.getUTCFullYear();
    
    let anchorDate = new Date(Date.UTC(year, 2, 20)); 
    if (inputDate < anchorDate) {
      anchorDate = new Date(Date.UTC(year - 1, 2, 20));
    }

    const diffTime = Math.abs(inputDate - anchorDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays >= 364) {
      setResult({ isJubilee: true, monthIndex: -1 });
      setActiveMonthIndex(-1);
      return;
    }

    const monthIndex = Math.floor(diffDays / 28);
    const dayIndex = diffDays % 28;

    setResult({
      isJubilee: false,
      monthIndex: monthIndex,
      monthName: ADONISIAN_MONTHS[monthIndex].name,
      dayNum: dayIndex + 1,
      totem: DAILY_TOTEMS[dayIndex],
    });
    
    setActiveMonthIndex(monthIndex);
  };

  useEffect(() => {
    calculateAdonisian(birthDate);
  }, [birthDate]);

  return (
    <div style={{ minHeight: '100vh', padding: '40px 15px', boxSizing: 'border-box', background: '#05070a', color: '#c9d1d9', fontFamily: 'monospace' }}>

{/* 👇 THE MOON CALCULATOR SEO SHIELD 👇 */}
      <Helmet>
        <title>26 Moon Calendar | Adonisian Astro-Somatic™</title>
        <meta name="description" content="Track the exact lunar phases through the true 13-sign astronomical wheel. Align your somatic fluid mechanics with the real-time lunar matrix." />
      </Helmet>

      <div className="moon-code-manifesto" style={{ maxWidth: '800px', margin: '0 auto 60px auto', textAlign: 'left', lineHeight: '1.8' }}>
        <h2 style={{ color: '#00d4ff', fontSize: '2rem', textTransform: 'uppercase', letterSpacing: '2px', textAlign: 'center' }}>
          The Somatic Lunar Matrix: Decoding the 13/4 Framework
        </h2>
        
        <p style={{ color: '#c9d1d9', fontSize: '1.05rem', marginTop: '20px' }}>
          The word "month" originates from the Latin <em>metri</em> (to measure). Yet, the standard 12-month calendar measures nothing in the physical universe. It is an arbitrary grid. To optimize the human biological vehicle, we must abandon synthetic time and align with the exact mathematical realities of the cosmos.
        </p>

        <blockquote style={{ borderLeft: '3px solid #ffca28', paddingLeft: '15px', margin: '30px 0', color: '#ffca28', fontStyle: 'italic', fontSize: '1.1rem' }}>
          "The Moon is not merely a celestial body; it is a bio-spiritual trigger. It dictates the ebb and flow of the Earth's oceans, and it dictates the tides of your Cerebrospinal Fluid (CSF)." 
        </blockquote>

        <h3 style={{ color: '#00ff41', marginTop: '30px' }}>The Mathematical Reality of the 13 Cycles</h3>
        <p style={{ color: '#8b949e', fontSize: '0.95rem' }}>
          The Moon operates on two distinct, measurable standards. The <strong>lunation cycle</strong> (New Moon to New Moon) is 29.53 days. The <strong>lunar orbital period</strong> (its journey through the fixed stars) is exactly 27.32 days. 
          <br/><br/>
          Dividing these cycles (29.53 / 27.32) yields <strong>1.080</strong>. This is a fundamental constant. The Moon’s physical diameter is exactly 2,160 miles. Half of that is 1,080—a geometric proportion echoed in the 108 nodes of the human energetic system and the structural blueprints of ancient architecture.
        </p>

        <h3 style={{ color: '#00d4ff', marginTop: '30px' }}>The 13 Joints & Cerebrospinal Activation</h3>
        <p style={{ color: '#8b949e', fontSize: '0.95rem' }}>
          Within one Earth year, the Moon cycles through the ecliptic precisely 13.36 times, creating 13 distinct New Moons and 13 Full Moons. This celestial architecture is mirrored identically in human biomechanics. 
          <br/><br/>
          There are exactly <strong>13 major joints</strong> in the human body: seven above (neck, shoulders, elbows, wrists) and six below (hips, knees, ankles). As the Moon traverses the 13 physical constellations, its gravitational and magnetic shifts act as specific triggers. The 13 New Moons serve as highly specific energetic windows, activating corresponding joint matrices and stimulating the flow of Cerebrospinal Fluid (CSF) through the spinal column. 
          <br/><br/>
          Understanding your specific coordinate within this 26-Moon Matrix is the first step in conscious neuro-somatic regulation.
        </p>
      </div>

      <h2 style={{ textAlign: 'center', color: '#ffffff', letterSpacing: '2px', marginTop: '60px', textTransform: 'uppercase', fontSize: '1.5rem' }}>
        Interactive 26-Moon Matrix
      </h2>
      <p style={{ textAlign: 'center', color: '#8b949e', marginBottom: '40px', fontSize: '0.9rem', padding: '0 15px' }}>
        Input your coordinates or click any node on the wheel to decode the celestial data.
      </p>

      {/* MOBILE RESPONSIVE FLEX CONTAINER */}
      <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center', alignItems: 'flex-start', paddingBottom: '60px' }}>
        
        {/* LEFT COLUMN: THE FLUID SVG WHEEL */}
        <div style={{ position: 'relative', width: '100%', maxWidth: '400px', aspectRatio: '1 / 1', margin: '0 auto' }}>
          <svg viewBox="0 0 100 100" aria-label="Astro-Somatic™ 26-Moon Calendar and Lunar Matrix Wheel" role="img" style={{ width: '100%', height: '100%', overflow: 'visible' }}>
            <title>13-Month Somatic Lunar Matrix</title>
            <circle cx="50" cy="50" r="48" fill="none" stroke="#1a1a1a" strokeWidth="0.5" strokeDasharray="2 2" />
            
            {ADONISIAN_MONTHS.map((m, i) => {
              const angle = (i * (360 / 13) - 90) * (Math.PI / 180);
              const x = 50 + 38 * Math.cos(angle);
              const y = 50 + 38 * Math.sin(angle);
              const isActive = activeMonthIndex === i;

              return (
                <g key={m.name} style={{ cursor: 'pointer' }} onClick={() => setActiveMonthIndex(i)}>
                  <circle 
                    cx={x} cy={y} r="5.5" 
                    fill={isActive ? "#ffca28" : "#0d1117"} 
                    stroke={isActive ? "#ffca28" : "#30363d"} 
                    strokeWidth="0.5"
                    style={{ transition: 'all 0.3s ease' }}
                  />
                  <text x={x} y={y} fontSize="3" textAnchor="middle" dominantBaseline="middle" fill={isActive ? "#000" : "#8b949e"}>
                    {m.icon}
                  </text>
                  <text 
                    x={50 + 46 * Math.cos(angle)} 
                    y={50 + 46 * Math.sin(angle)} 
                    fontSize="1.6" 
                    fill={isActive ? "white" : "#484f58"} 
                    textAnchor="middle"
                    transform={`rotate(${(angle * 180 / Math.PI) + 90}, ${50 + 46 * Math.cos(angle)}, ${50 + 46 * Math.sin(angle)})`}
                  >
                    {m.name.toUpperCase()}
                  </text>
                </g>
              );
            })}

            <circle cx="50" cy="50" r="12" fill="#0d1117" stroke={activeMonthIndex === -1 ? "#ffca28" : "#30363d"} strokeWidth="0.5" />
            <text x="50" y="50" fontSize="4" textAnchor="middle" dominantBaseline="middle" fill={activeMonthIndex === -1 ? "#ffca28" : "#00d4ff"}>𓂀</text>
          </svg>
        </div>

        {/* RIGHT COLUMN: DYNAMIC DATA DISPLAY */}
        <div style={{ flex: '1 1 300px', width: '100%', display: 'flex', flexDirection: 'column', gap: '20px', boxSizing: 'border-box' }}>
          
          <div style={{ background: '#0d1117', padding: '20px', borderRadius: '12px', border: '1px solid #30363d' }}>
            <h3 style={{ color: 'white', marginTop: 0, fontSize: '1.1rem' }}>ANCHOR YOUR COORDINATES</h3>
            <input 
              type="date" 
              value={birthDate} 
              onChange={(e) => setBirthDate(e.target.value)}
              style={{ width: '100%', padding: '12px', background: '#05070a', color: 'white', border: '1px solid #00d4ff', borderRadius: '4px', fontSize: '1rem', fontFamily: 'monospace', boxSizing: 'border-box' }}
            />
            {result && activeMonthIndex === result.monthIndex && (
              <div style={{ marginTop: '20px', padding: '15px', background: 'rgba(0, 212, 255, 0.05)', borderRadius: '6px', border: '1px solid #00d4ff' }}>
                <span style={{ color: '#00d4ff', fontSize: '0.8rem', textTransform: 'uppercase' }}>Your Totemic Identity:</span>
                <h2 style={{ color: 'white', margin: '5px 0', fontSize: '1.6rem' }}>{result.totem} {result.monthName.replace('The ', '')}</h2>
                <span style={{ color: '#8b949e', fontSize: '0.85rem' }}>Day {result.dayNum} of Month {result.monthIndex + 1}</span>
              </div>
            )}
          </div>

          {activeMonthIndex !== null && activeMonthIndex !== -1 && (
            <div style={{ background: '#0d1117', padding: '20px', borderRadius: '12px', border: '1px solid #ffca28', boxShadow: '0 0 20px rgba(255, 202, 40, 0.05)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #30363d', paddingBottom: '10px', marginBottom: '15px' }}>
                <h3 style={{ color: '#ffca28', margin: 0, fontSize: '1.2rem' }}>
                  Month {activeMonthIndex + 1}: {ADONISIAN_MONTHS[activeMonthIndex].name}
                </h3>
                <span style={{ fontSize: '1.5rem' }}>{ADONISIAN_MONTHS[activeMonthIndex].icon}</span>
              </div>
              
              <p style={{ color: '#c9d1d9', fontSize: '0.95rem', marginBottom: '20px' }}>
                <strong style={{ color: '#8b949e' }}>Standard Gregorian Span:</strong><br/>
                {ADONISIAN_MONTHS[activeMonthIndex].range}
              </p>

              <h4 style={{ color: '#00d4ff', borderBottom: '1px dashed #30363d', paddingBottom: '5px', marginBottom: '15px', fontSize: '1rem' }}>
                2026 Somatic Moon Triggers
              </h4>
              
              {LUNAR_EVENTS_2026[activeMonthIndex] ? (
                LUNAR_EVENTS_2026[activeMonthIndex].map((moon, idx) => (
                  <div key={idx} style={{ marginBottom: '15px', background: '#05070a', padding: '12px', borderRadius: '6px', borderLeft: `3px solid ${moon.phase === "Full Moon" ? "#ffca28" : "#00d4ff"}` }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', marginBottom: '8px', gap: '5px' }}>
                      <strong style={{ color: 'white', fontSize: '0.9rem' }}>{moon.phase} in {moon.sign}</strong>
                      <span style={{ color: '#8b949e', fontSize: '0.8rem' }}>{moon.date}</span>
                    </div>
                    <div style={{ fontSize: '0.8rem', color: '#c9d1d9', lineHeight: '1.5' }}>
                      <span style={{ color: '#ffca28' }}>Somatic Node:</span> {moon.somatic}<br/>
                      <span style={{ color: '#00ff41' }}>Chakra Nexus:</span> {moon.chakra}
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ color: '#8b949e', fontStyle: 'italic', fontSize: '0.85rem' }}>Data pending...</p>
              )}
            </div>
          )}

          {activeMonthIndex === -1 && (
            <div style={{ background: '#0d1117', padding: '25px', borderRadius: '12px', border: '1px solid #ffca28', textAlign: 'center' }}>
              <h1 style={{ color: '#ffca28', margin: '0 0 10px 0', fontSize: '1.8rem' }}>✨ THE JUBILEE ✨</h1>
              <p style={{ color: '#c9d1d9', fontSize: '0.95rem' }}>
                The Day Out of Time. March 19th.<br/>A state of pure Adonisia and biological stillness before the cycle resets.
              </p>
            </div>
          )}
        </div>
      </div>
      <div style={{ textAlign: 'center', paddingBottom: '30px' }}>
        <Link to="/" style={linkStyle}>The Portal 📟</Link>
      </div>
    </div>
  );
}